import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalComponent } from '@tecalisdev/infinity';
import { PwcsInlineSvgComponent } from 'src/app/shared/components/pwcs-inline-svg/pwcs-inline-svg.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'app-modal-work-life-help',
	templateUrl: './modal-work-life-help.component.html',
	styleUrls: ['./modal-work-life-help.component.scss'],
	imports: [ModalComponent, TranslatePipe, PwcsInlineSvgComponent],
})
export class ModalWorkLifeHelpComponent {
	@Input() isVisible: boolean = false;
	@Input() url: string;
	@Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	public closeModal(): void {
		this.isVisible = false;
		this.isVisibleChange.emit(false);
	}
}
